export const normalizePassportNumber = (passportNumber: string | number): string => {
  // Convert to string and clean up
  const cleaned = String(passportNumber)
    .trim()
    .replace(/\s+/g, '') // Remove all whitespace
    .replace(/[^\w\d]/g, ''); // Remove special characters
    
  return cleaned;
};

export const normalizePassportForMatch = (passportNumber: string | number): string => {
  const normalized = normalizePassportNumber(passportNumber).toUpperCase();
  return normalized.startsWith('PASSPORT') ? normalized.slice('PASSPORT'.length) : normalized;
};

const formatPassportNumber = (passportNumber: string | number): string => {
  return String(passportNumber).trim();
};

const validatePassportNumber = (passportNumber: string | number): boolean => {
  const formatted = formatPassportNumber(passportNumber);
  return formatted.length > 0;
};
